import {datadogRum} from '@datadog/browser-rum';

import getFormVersion from '../../../../utils/getFormVersion';
import {addToDataLayer} from '../../../../utils/pageUtils';
import {FormAssets, FormGoals} from '../types';

interface TrackingValues {
  user_experience: 'Yes' | 'No';
  user_goal_1: FormGoals;
  user_goal_2: FormGoals;
  user_goal_3: FormGoals;
  user_goal_4: FormGoals;
  user_salary: number;
  assets_1: FormAssets;
  assets_2: FormAssets;
  assets_3: FormAssets;
  assets_4: FormAssets;
  assets_5: FormAssets;
  assets_6: FormAssets;
  user_asset_value: number;
  user_location: string;
  user_age: number;
  user_name: string;
}

export const TRACKING_DEFAULTS: FAAFDataLayerValues = {
  action: null,
  user_experience: null,
  user_goal_1: null,
  user_goal_2: null,
  user_goal_3: null,
  user_goal_4: null,
  user_salary: null,
  assets_1: null,
  assets_2: null,
  assets_3: null,
  assets_4: null,
  assets_5: null,
  assets_6: null,
  user_asset_value: null,
  user_location: null,
  user_age: null,
  user_name: null,
};

export type FAAFDataLayerValues = Record<string, unknown> &
  Partial<TrackingValues> & {
    /* Tracking step names */
    action:
      | 'experience' // has advisor
      | 'goals'
      | 'age'
      | 'income'
      | 'assets'
      | 'location'
      | 'about you'
      | 'phone';
  };

interface TrackingEventParams {
  values?: Partial<FAAFDataLayerValues>;
  currentStep?: string;
  experiments?: Experiments;
}
type LogTrackingEvent = (params?: TrackingEventParams) => void;

const logTrackingEvent: LogTrackingEvent = (params) => {
  const {values = {}, currentStep, experiments = {}} = params || {};
  const datadogAction = currentStep ? `FAAF_${currentStep}` : 'FAAF_formStart';
  const defaults = {
    title: 'Find An Advisor',
    page_URL: document.location.href,
    version: getFormVersion([], experiments),
  };
  const finalValues = {
    ...defaults,
    ...values,
  };

  datadogRum.addAction(datadogAction, finalValues);
  addToDataLayer({
    overrideBase: 'form_entry',
    values: finalValues,
  });
};

export default logTrackingEvent;
